module.exports = __webpack_public_path__ + "img/back01.88892a49.png";